<template>
  <div>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          :disabled="disabled"
          :hide-details="hideDetails"
          :label="isShowLabel ? 'Ngày' : null"
          :placeholder="placeholder"
          :value="date | familiarizeDate"
          dense
          outlined
          :class="{ 'input--error': !rule }"
          v-on="on"
          :rules="rules"
          @input="validate"
          clearable
          readonly
          @click:clear="() => dateChange(null)"
        >
          {{ date | familiarizeDate }}
        </v-text-field>
      </template>
      <v-date-picker color="primary" v-model="date" @click:date="dateChange" scrollable>
        <div class="flex-grow-1"></div>
      </v-date-picker>
      <div v-if="!rule" class="error-text px-3">{{ 'Sai định dạng ngày' }}</div>
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'SelectDate',
  props: {
    max: moment().toISOString(),
    disabled: Boolean,
    placeholder: String,
    existedDate: {
      type: String,
      default: null
    },
    isShowLabel: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    date: null,
    menu: false,
    rule: true
  }),
  methods: {
    dateChange(date) {
      if (date === null) this.$emit('change', null)
      else {
        this.$emit(
          'change',
          moment(this.date)
            .startOf('day')
            .toISOString()
        )
      }
      this.$refs.menu.save(date)
      this.menu = false
    },
    updateDate(newVal) {
      if (newVal && !isNaN(new Date(newVal).getTime())) {
        this.date = moment(newVal).format('YYYY-MM-DD')
      } else this.date = null
    },
    validate() {
      this.rule = isNaN(new Date(this.date).getTime())
    }
  },
  watch: {
    existedDate: {
      handler(newVal) {
        if (newVal) {
          this.updateDate(newVal)
        } else this.date = null
      },
      immediate: true
    }
  },
  filters: {
    familiarizeDate: time => {
      if (!time) {
        return ''
      }
      return moment(time, 'YYYY-MM-DD').format('DD/MM/YYYY')
    }
  }
}
</script>

<style lang="scss" scoped>
.error-text {
  color: #fd6b6b !important;
  margin-top: 4px;
  min-height: 14px;
  line-height: 14px;
  position: absolute;
  white-space: nowrap;
}
</style>
